import React from "react";

const Refresh = () => {

    return <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="21.748" height="21" viewBox="0 0 21.748 21">
            <path d="M52.2,40.962h.4a1.122,1.122,0,0,0,1.125-1.125v-6a1.126,1.126,0,0,0-1.922-.8l-1.95,1.95A10.5,10.5,0,1,0,49.9,49.886a1.5,1.5,0,0,0-2.123-2.123,7.5,7.5,0,1,1-.047-10.653L45.8,39.041a1.126,1.126,0,0,0,.8,1.922Z" transform="translate(-31.975 -31.962)" fill="currentColor"/>
        </svg>
    </div>

}


export default Refresh;
